import React from "react";
import styles from "../Assets/css/test.module.css";
import RectangleX from "../Assets/img/Home/Rectangle 1032.png";
import RectangleY from "../Assets/img/course/Rectangle 1027.png";
function PlacementCourseImages() {
	return (
		<div
			className="container-fluid"
			style={{
				marginTop: "5%",
				marginBottom: "-20px",
				padding: "4px",
				backgroundColor: "#00a2c8",
			}}
		>
			<div className="row " style={{ height: "38vh" }}>
				<div className="col-md-4 col-xs-12 col-lg-4 col-sm-6 ">
					<img
						src={RectangleX}
						className={`img-fluid ${styles.imagefull}`}
						style={{ marginBottom: "-30px" }}
					/>
				</div>
				<div
					className="col-md-5 col-xs-12 col-12"
					style={{ transform: "translateX(20%)" }}
				>
					<br />
					<br />
					<h1
						style={{
							color: "white",
							fontFamily: "Poppins-SemiBold",
						}}
					>
						100% Job Assistance
					</h1>
					<br />
					<a
						href="#ptable"
						style={{
							fontSize: "20px",
							borderRadius: "25px",
							width: "50%",
							fontFamily: "Poppins-SemiBold",
							marginBotom: "-60px",
						}}
						className="btn btn-warning text-white "
					>
						Enroll Now
					</a>
				</div>
			</div>
		</div>
	);
}

export default PlacementCourseImages;
